import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import appLogin from "assets/commonjs/app";
import {getQueryString} from 'assets/commonjs/tool';

// import "./assets/rem";
import './assets/styles/common.scss'
import api from "./api/index"; // 导入api接口
Vue.config.productionTip = false
import {Popup,ImagePreview } from 'vant';
Vue.use(Popup).use(ImagePreview )
Vue.prototype.$api = api; // 将api挂载到vue的原型上

import {Loading} from 'vant'
Vue.use(Loading)

// if (getQueryString("noneheader")) {
// //   setInterval(() => {
//     appLogin.getAppUserInfo();
// //   }, 1000);
// }







// import VueI18n from 'vue-i18n'
// Vue.use(VueI18n)
// let lang = 'cn'
// if(getStore('lang')){
//     lang = getStore('lang')  
// }
// const i18n = new VueI18n({

//   locale: lang,    // 语言标识
//   //this.$i18n.locale // 通过切换locale的值来实现语言切换
//   messages: {
//     'cn': require('../src/assets/lang/lang-vn'),  // 中文语言包
//     'en': require('../src/assets/lang/lang-en')    // 英文语言包
//   }
// })

new Vue({
  router,
  store,
  // i18n,
  render: h => h(App)
}).$mount("#app");
